import { render, staticRenderFns } from "./DocHubObject.vue?vue&type=template&id=8b59286a&scoped=true"
import script from "./DocHubObject.vue?vue&type=script&lang=js"
export * from "./DocHubObject.vue?vue&type=script&lang=js"
import style0 from "./DocHubObject.vue?vue&type=style&index=0&id=8b59286a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b59286a",
  null
  
)

export default component.exports